
// eslint-disable-next-line import/no-anonymous-default-export
export default [
    { id:0, title: 'General' },
    { id:1, title: 'Monitors' },
    { id:2, title: 'Students' },
    { id:3, title: 'Employees' },
]
